import { Component, Input } from '@angular/core';
import { ScreenType } from '@fgb/core';

@Component({
  selector: 'fgb-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  screenType = ScreenType;

  @Input() title: string;
}
